/* tslint:disable */
/* eslint-disable */
/**
 * Shifts API
 * API to get shifts
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Employees,
    EmployeesFromJSON,
    EmployeesFromJSONTyped,
    EmployeesToJSON,
} from './Employees';
import {
    PaginationPage,
    PaginationPageFromJSON,
    PaginationPageFromJSONTyped,
    PaginationPageToJSON,
} from './PaginationPage';

/**
 * 
 * @export
 * @interface ShiftApplicantsResponse
 */
export interface ShiftApplicantsResponse {
    /**
     * List of applicants that needs to be approved by the planner.
     * @type {Array<Employees>}
     * @memberof ShiftApplicantsResponse
     */
    resultList: Array<Employees>;
    /**
     * 
     * @type {PaginationPage}
     * @memberof ShiftApplicantsResponse
     */
    page: PaginationPage;
}

export function ShiftApplicantsResponseFromJSON(json: any): ShiftApplicantsResponse {
    return ShiftApplicantsResponseFromJSONTyped(json, false);
}

export function ShiftApplicantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftApplicantsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultList': ((json['resultList'] as Array<any>).map(EmployeesFromJSON)),
        'page': PaginationPageFromJSON(json['page']),
    };
}

export function ShiftApplicantsResponseToJSON(value?: ShiftApplicantsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resultList': ((value.resultList as Array<any>).map(EmployeesToJSON)),
        'page': PaginationPageToJSON(value.page),
    };
}

